<template>
<!--  <nav class="navbar navbar-expand-lg navbar-dark bg-dark">-->
<!--    <div class="container-fluid">-->
<!--      <ul class="navbar-nav me-auto mb-2 mb-lg-0">-->
<!--        <li class="nav-item dropdown">-->
<!--          <a class="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button" data-bs-toggle="dropdown"-->
<!--             aria-expanded="false">-->
<!--            Api-->
<!--          </a>-->
<!--          <ul class="dropdown-menu" aria-labelledby="navbarDropdown">-->
<!--            <li><a class="dropdown-item" href="#">Action</a></li>-->
<!--            <li><a class="dropdown-item" href="#">Another action</a></li>-->
<!--          </ul>-->
<!--        </li>-->
<!--      </ul>-->
<!--    </div>-->
<!--  </nav>-->
    <router-view></router-view>
</template>

<style>
</style>